module.exports = __webpack_public_path__ + "img/pointing-laughing.7bc3d2c4.png";